import { useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/hotelData';

export default function FeaturedArticles() {
  const navigate = useNavigate();
  const featuredArticles = articles.slice(0, 3);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-10 md:mb-14">
          <div>
            <span className="text-xs md:text-sm text-primary-600 tracking-widest uppercase font-medium">
              Travel Guide
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2">
              澳门旅游攻略
            </h2>
          </div>
          <button
            onClick={() => navigate('/category/articles')}
            className="mt-3 md:mt-0 flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部攻略 <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featuredArticles.map((article) => (
            <article
              key={article.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
              onClick={() => navigate(`/article/${article.slug}`)}
            >
              <div className="relative h-44 md:h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={`${article.title} - 新葡京酒店攻略`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.author}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{article.excerpt}</p>
                <div className="flex items-center gap-2 mt-4 flex-wrap">
                  {article.tags.map((tag) => (
                    <span key={tag} className="px-2 py-0.5 bg-background-100 text-foreground-500 text-xs rounded-md">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}